/** localStorage, or null when the browser refuses access (private mode, policy). */
export function navigationStorage(): Storage | null {
  try {
    return typeof window === "undefined" ? null : window.localStorage;
  } catch {
    return null;
  }
}
